import cn from "classnames"
import React from "react"

interface DotSpinnerProps {
  center?: boolean
  className?: string
  white?: boolean
}

const DotSpinner: React.FC<DotSpinnerProps> = ({ center, className, white }) => {
  const dotClass = cn("block h-[6px] w-[6px] animate-blink-fast rounded-full", {
    "bg-white": white,
    "bg-slate-400": !white,
  })

  return (
    <div className={cn("h-[6px] w-[30px]", { "mx-auto my-0": center }, className)}>
      <span className="flex justify-between">
        <i className={dotClass} style={{ animationDelay: "-0.2s" }}></i>
        <i className={dotClass} style={{ animationDelay: "-0.1s" }}></i>
        <i className={dotClass}></i>
      </span>
    </div>
  )
}

export default DotSpinner
